import { checkRut, prettifyRut, removeSeparators } from 'react-rut-formatter';
import { validateRfc } from './forms';

export const VALIDATORS = {
  Chile: (nationalIdentifier) => checkRut(nationalIdentifier),
  Mexico: (nationalIdentifier) => validateRfc(nationalIdentifier),
};

export const SETTERS = {
  Chile: (nationalIdentifier) => prettifyRut(nationalIdentifier),
  Mexico: (nationalIdentifier) => nationalIdentifier,
};

export const RUT_WITHOUT_DV = {
  Chile: (nationalIdentifier) => removeSeparators(nationalIdentifier).slice(0, -1).replace(/\./g, ''),
  Mexico: (nationalIdentifier) => nationalIdentifier,
};
